<template>
  <app-bar>
    <back-button />
  </app-bar>
  <router-view />
</template>

<script>
import AppBar from "@/components/AppBar.vue";
import BackButton from "@/components/button/BackButton.vue";

export default {
  name: "DetailsPageLayout",
  components: { AppBar, BackButton },
};
</script>
